import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';
import { separateThousands } from '@alfa-bank/site-helpers-transform/numbers/separate-thousands';

import { isNumber } from '../../helpers';

import styles from './styles.css';

interface IPriceRendererProps {
    className?: string;
    fallbackValue?: string | null;
    symbol?: string;
    value?: number | null;
}

/** Обрабатывает абсолютные значения, типа lastPrice и profitability */
export const PriceRenderer: FC<IPriceRendererProps> = ({
    className,
    fallbackValue = null,
    symbol = '',
    value,
}) => {
    const priceSymbol = symbol === '%' ? symbol : ` ${symbol}`;
    const result = isNumber(value) ? `${separateThousands(value)}${priceSymbol}` : fallbackValue;

    return <span className={cn(styles.text, className)}>{result}</span>;
};
